import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, vModelRadio as _vModelRadio, withDirectives as _withDirectives, vModelText as _vModelText, vShow as _vShow, withModifiers as _withModifiers, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "title" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "reason-for-contact" }
const _hoisted_4 = ["id", "name", "value"]
const _hoisted_5 = ["for"]
const _hoisted_6 = { class: "form-group contact-reason" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = { class: "disclosure" }

import { inject, ref, computed, onMounted } from "vue";
import { useStore } from "vuex";
import { $api } from "@/services/api";
import StarRating from "@/components/shared/feedback/StarRating.vue";
import { PostFeedbackRequest, FeedbackRequestOption } from "@/models/feedback";


export default /*@__PURE__*/_defineComponent({
  __name: 'Feedback',
  emits: ["showSupportModal"],
  setup(__props, { emit: __emit }) {

const store = useStore();
const gtag = inject<any>("gtag");
const title = ref<string>("How would you rate your experience?");
const displayFeedbackForm = ref<boolean>(false);
const rating = ref<number>(0);
const hoverRating = ref<number>(0);
const categoryId = ref<number>(0);
const message = ref<string>("");
const errorMessage = ref<string>("");
const sending = ref<boolean>(false);
const submitted = ref<boolean>(false);
const oidcUser = computed(() => store.getters['oidcStore/oidcUser']);
const options = computed(() => store.getters['lookupsModule/feedbackFormOptions']);
const lenderId = computed(() => store.state?.appData?.application?.lenderId);
const applicantId = computed(() => store.state?.appData?.currentApplicant?.id);
const applicationId = computed(() => store.state?.appData?.application?.id);
const defaultOptionId = computed(() => options.value?.find((o: FeedbackRequestOption) => o?.category === 'General')?.id)
const emit = __emit;

function reset() {
  title.value = "How would you rate your experience?";
  submitted.value = false;
  rating.value = 0;
  hoverRating.value = 0;
  categoryId.value = 0;
  message.value = "";
  errorMessage.value = "";
}

function closeFeedback() {
  displayFeedbackForm.value = false;
  setTimeout(() => {
    reset();
  }, 500);
}

function setHoverRating(event: any) {
  hoverRating.value = event.hoverRating;
}

function setRating(event: any) {
  rating.value = event.rating;
}

function handleError() {
  sending.value = false;
  errorMessage.value = "Feedback could not be submitted.";
}

function displayFeedback() {
  displayFeedbackForm.value = true;
  gtag.event("feedback_opened", {
    event_category: "engagement",
    event_label: "Feedback Opened"
  });
}

function submitFeedback() {
  sending.value = true;
  errorMessage.value = "";

  $api.feedback
    .sendFeedback({
      formId: 3, // Applicant Portal User Initiated
      lenderId: lenderId.value,
      categoryId: categoryId.value <= 0 ? defaultOptionId.value : categoryId.value, // default to general if they don't select
      rating: rating.value,
      message: message.value,
      unifiId: oidcUser.value.sub,
      metadata: {
        applicantId: applicantId.value,
        applicationId: applicationId.value
      }
    } as PostFeedbackRequest)
    .then((result: any) => {
      if (result.error) {
        handleError();
      } else {
        title.value = "Thank you for sharing your feedback with us!";
        sending.value = false;
        submitted.value = true;
      }
    })
    .catch((error: any) => {
      console.log("ERROR", error);
      handleError();
    });
}

onMounted(() => {
  store.dispatch('lookupsModule/getFeedbackFormOptions');
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "feedback-tab",
      onClick: displayFeedback
    }, [...(_cache[4] || (_cache[4] = [
      _createElementVNode("p", null, "Feedback", -1)
    ]))]),
    _createElementVNode("div", {
      class: _normalizeClass(["feedback-form", { active: displayFeedbackForm.value, submitted: submitted.value }])
    }, [
      _createElementVNode("button", {
        type: "button",
        class: "close-btn",
        onClick: closeFeedback
      }, " X "),
      _createElementVNode("p", _hoisted_1, _toDisplayString(title.value), 1),
      (submitted.value)
        ? (_openBlock(), _createElementBlock("p", _hoisted_2, " We appreciate your input about your experience on our site. This information will be used to help us improve. "))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createVNode(StarRating, {
              rating: rating.value,
              hoverRating: hoverRating.value,
              onRating: setRating,
              onHoverRating: setHoverRating,
              onMouseleave: _cache[0] || (_cache[0] = ($event: any) => (hoverRating.value = 0))
            }, null, 8, ["rating", "hoverRating"]),
            _createElementVNode("div", _hoisted_3, [
              _cache[5] || (_cache[5] = _createElementVNode("p", null, "Reason for Contacting Us", -1)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(options.value, (option, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "custom-control custom-radio custom-control-inline"
                }, [
                  _withDirectives(_createElementVNode("input", {
                    type: "radio",
                    id: option?.category?.toLowerCase(),
                    name: option?.category?.toLowerCase(),
                    value: option?.id,
                    class: "custom-control-input",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((categoryId).value = $event))
                  }, null, 8, _hoisted_4), [
                    [_vModelRadio, categoryId.value]
                  ]),
                  _createElementVNode("label", {
                    class: "custom-control-label",
                    for: option?.category?.toLowerCase()
                  }, _toDisplayString(option?.category), 9, _hoisted_5)
                ]))
              }), 128)),
              _withDirectives(_createElementVNode("div", _hoisted_6, [
                _withDirectives(_createElementVNode("textarea", {
                  class: "form-control",
                  id: "contactReason",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((message).value = $event)),
                  placeholder: "Share your experience but refrain from including any sensitive personal information such as account numbers or usernames.",
                  rows: "4",
                  maxlength: "800"
                }, null, 512), [
                  [_vModelText, message.value]
                ])
              ], 512), [
                [_vShow, categoryId.value > 0]
              ])
            ]),
            _withDirectives(_createElementVNode("div", { class: "error-message" }, _toDisplayString(errorMessage.value), 513), [
              [_vShow, errorMessage.value !== '']
            ]),
            _createElementVNode("button", {
              type: "button",
              class: "btn feedback-btn",
              disabled: rating.value <= 0 || sending.value,
              onClick: _withModifiers(submitFeedback, ["prevent"])
            }, _toDisplayString(sending.value ? "Sending..." : "Send Feedback"), 9, _hoisted_7),
            _createElementVNode("p", _hoisted_8, [
              _cache[6] || (_cache[6] = _createTextVNode(" Thank you for your feedback! If you require a response, please click ", -1)),
              _createElementVNode("span", {
                class: "underline",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('showSupportModal')))
              }, "here"),
              _cache[7] || (_cache[7] = _createTextVNode(" for support options. ", -1))
            ])
          ], 64))
    ], 2)
  ], 64))
}
}

})